// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yw57N","content":"styles_content__2WQBW"};